define(function (require){
    "use strict";

    var Marionette  = require('marionette');
    var Backbone    = require('backbone');
    var _           = require('underscore');
    var AppConfig   = require('config/application');

    return Marionette.ItemView.extend({
        template : '<span class="badge badge-important">{{#if number}} {{ number }} {{/if}}</span>',
        className: 'fa fa-file-text-o js-btn-notes',

        initialize : function (){
            _.bindAll(this, 'start');
            this.listenTo(app.Vents, 'app:initChat', this.start);
        },

        start : function (){
            var self = this, userId;
            this.model = new Backbone.Model();
            this.listenTo(this.model, 'change', this.render);
            this.listenTo(app.Collections.ChatMessagesCount, 'change:messagesNumber add', this.collectionChanged);
            this.listenTo(app.Vents, 'chat:openDialog', this.clearMessageCountFrom);
            this.listenTo(app.Vents, 'message:getNewMessage', function (data){
                if(typeof app.Models.CurrentChat !== 'undefined'){
                    if(app.Models.CurrentChat.get('isOpen')){
                        userId = data.fromUser.replace('employee', '');
                        userId = data.fromUser.replace('main', '');
                        this.clearMessageCountFrom(userId);
                    } else {
                        self.countChatMessages(data);
                    }
                } else {
                    self.countChatMessages(data);
                }
            });

        },

        collectionChanged : function (){
            var chatCounter = 0;
            app.Collections.ChatMessagesCount.each(function(model){
                chatCounter += parseInt(model.get('messagesNumber'));
            });
            this.model.set({ number : chatCounter });

            chatCounter = 0;
        },

        countChatMessages : function (data){
            var chatCounter = 0, isDialogExists = false, userId;
            userId = data.fromUser.replace('employee', '');
            userId = data.fromUser.replace('main', '');

            app.Collections.ChatMessagesCount.each(function(model){
                if(model.get('userChatId') == data.fromUser){
                    chatCounter = parseInt(model.get('messagesNumber'));
                    chatCounter++;

                    model.set({
                        messagesNumber : chatCounter,
                        userId         : parseInt(userId)
                    });
                    isDialogExists = true;
                }
            });

            if(!isDialogExists){
                chatCounter = 1;
                app.Collections.ChatMessagesCount.add( new Backbone.Model({
                    userChatId       : data.fromUser,
                    messagesNumber   : chatCounter,
                    userId           : parseInt(userId)
                }) );
            }

            app.Vents.trigger('chat:messageReceived', {userId : parseInt(userId), number : chatCounter});
        },

        clearMessageCountFrom : function (userId){
            app.Collections.ChatMessagesCount.each(function (model){
                if(model.get('userId') == userId){
                    model.set('messagesNumber', 0);
                }
            });
        }
    });
});